import React, { useState } from 'react';
import { Check, Bookmark } from 'lucide-react';
import { Link } from 'react-router-dom';

export const SaveResultButton = ({ onSave, saved }) => {
  const [justSaved, setJustSaved] = useState(false);

  const handleSave = () => {
    onSave();
    setJustSaved(true);
    setTimeout(() => setJustSaved(false), 2500);
  };

  if (justSaved || saved) {
    return (
      <div className="flex items-center justify-center gap-3 py-3 border border-[#22c55e]/30 bg-[#22c55e]/10 text-[#22c55e] text-sm" data-testid="result-saved-indicator">
        <Check className="w-4 h-4" />
        <span className="font-heading uppercase tracking-wider">Saved to My Dashboard</span>
        <Link to="/my-results" className="text-[#00F0FF] hover:text-white transition-colors text-xs ml-2">View &rarr;</Link>
      </div>
    );
  }

  return (
    <button
      onClick={handleSave}
      className="w-full flex items-center justify-center gap-2 py-3 border border-zinc-700 bg-zinc-900 text-zinc-300 hover:border-[#00F0FF] hover:text-white transition-all text-sm"
      data-testid="save-result-btn"
    >
      <Bookmark className="w-4 h-4" />
      <span className="font-heading uppercase tracking-wider">Save to My Dashboard</span>
    </button>
  );
};
